module.exports = __webpack_public_path__ + "img/pandamail_logo.efe85f1f.svg";